// ============================================================
// cf-color-picker.js � Reusable Color Picker Helper
// Load hanya pada halaman yang membutuhkan color picker.
//
// Dependencies: cf-form-helpers.js (CF.formHelpers.escHtml)
//
// Provides CF.colorPicker with:
//   CF.colorPicker.open(opts)    � Open color picker popover
//   CF.colorPicker.close()       � Close color picker popover
//   CF.colorPicker.SWATCHES      � Default swatch palette
//
// Usage:
//   CF.colorPicker.open({
//       textId:    'my-color-input',     // required: text input to write hex value
//       triggerId: 'my-color-btn',       // required: button that opens the popover (for positioning)
//       dotId:     'my-color-dot',       // optional: color preview dot element
//       previewId: 'my-icon-preview',    // optional: icon preview element to update
//       iconInputId: 'my-icon-input',    // optional: icon input (for updating icon preview with color)
//       onSave:    function(hex) { },    // optional: callback after save
//       onClear:   function() { }        // optional: callback after clear
//   });
//
// HTML structure (auto-injected on first open):
//   - Fixed popover with SV canvas, hue slider, swatch grid,
//     hex input, save/clear buttons
//   - Positions near the trigger button
// ============================================================

window.CF = window.CF || {};

CF.colorPicker = (function () {
    'use strict';

    // ????????????????????????????????????????????????????????
    // Default swatch palette
    // ????????????????????????????????????????????????????????
    var SWATCHES = [
        '#1E293B', '#374151', '#6B7280', '#DC2626', '#EF4444', '#F97316',
        '#EA580C', '#D97706', '#F59E0B', '#CA8A04', '#16A34A', '#22C55E',
        '#10B981', '#0D9488', '#14B8A6', '#06B6D4', '#0284C7', '#3B82F6',
        '#4F46E5', '#6366F1', '#7C3AED', '#8B5CF6', '#A855F7', '#C026D3',
        '#DB2777', '#EC4899', '#F43F5E', '#FFFFFF'
    ];

    // ????????????????????????????????????????????????????????
    // State
    // ????????????????????????????????????????????????????????
    var _currentOpts = null;
    var _injected = false;

    // HSV state for canvas interaction
    var _hue = 0;       // 0-360
    var _sat = 1;       // 0-1
    var _val = 1;       // 0-1
    var _draggingSV = false;
    var _draggingHue = false;

    // ????????????????????????????????????????????????????????
    // Color conversion helpers
    // ????????????????????????????????????????????????????????
    function hsvToRgb(h, s, v) {
        var c = v * s;
        var x = c * (1 - Math.abs(((h / 60) % 2) - 1));
        var m = v - c;
        var r = 0, g = 0, b = 0;
        if (h < 60)       { r = c; g = x; b = 0; }
        else if (h < 120) { r = x; g = c; b = 0; }
        else if (h < 180) { r = 0; g = c; b = x; }
        else if (h < 240) { r = 0; g = x; b = c; }
        else if (h < 300) { r = x; g = 0; b = c; }
        else               { r = c; g = 0; b = x; }
        return {
            r: Math.round((r + m) * 255),
            g: Math.round((g + m) * 255),
            b: Math.round((b + m) * 255)
        };
    }

    function rgbToHsv(r, g, b) {
        r /= 255; g /= 255; b /= 255;
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var d = max - min;
        var h = 0, s = max === 0 ? 0 : d / max, v = max;
        if (d !== 0) {
            if (max === r)      h = ((g - b) / d + 6) % 6;
            else if (max === g) h = (b - r) / d + 2;
            else                h = (r - g) / d + 4;
            h *= 60;
        }
        return { h: h, s: s, v: v };
    }

    function hexToRgb(hex) {
        hex = hex.replace(/^#/, '');
        if (hex.length === 3) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        if (hex.length !== 6) return null;
        var num = parseInt(hex, 16);
        if (isNaN(num)) return null;
        return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
    }

    function rgbToHex(r, g, b) {
        return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
    }

    function hsvToHex(h, s, v) {
        var rgb = hsvToRgb(h, s, v);
        return rgbToHex(rgb.r, rgb.g, rgb.b);
    }

    // ????????????????????????????????????????????????????????
    // Inject popover HTML (once)
    // ????????????????????????????????????????????????????????
    function _ensureInjected() {
        if (_injected) return;
        _injected = true;

        var swatchHtml = '';
        SWATCHES.forEach(function (c) {
            swatchHtml += '<button type="button" class="cf-cp-swatch" data-color="' + c + '" ' +
                'style="background:' + c + (c === '#FFFFFF' ? ';border:1px solid #E2E8F0' : '') + '" title="' + c + '"></button>';
        });

        var html =
            '<div id="cf-color-picker-popover" class="cf-cp-popover" style="display:none">' +
                '<div class="cf-cp-preview-bar">' +
                    '<div id="cf-cp-color-preview" class="cf-cp-preview-block" style="background:#6366F1"></div>' +
                '</div>' +
                '<div class="cf-cp-body">' +
                    // SV Canvas
                    '<div class="cf-cp-canvas-wrap">' +
                        '<canvas id="cf-cp-sv-canvas" width="240" height="150"></canvas>' +
                        '<div id="cf-cp-sv-cursor" class="cf-cp-sv-cursor"></div>' +
                    '</div>' +
                    // Hue Slider
                    '<div class="cf-cp-hue-wrap">' +
                        '<canvas id="cf-cp-hue-canvas" width="240" height="14"></canvas>' +
                        '<div id="cf-cp-hue-cursor" class="cf-cp-hue-cursor"></div>' +
                    '</div>' +
                    // Swatch Grid
                    '<div id="cf-cp-swatch-grid" class="cf-cp-swatch-grid">' + swatchHtml + '</div>' +
                    // Hex Input
                    '<div class="cf-cp-hex-row">' +
                        '<span class="cf-cp-hex-label">#</span>' +
                        '<input type="text" id="cf-cp-hex-input" class="cf-cp-hex-input" placeholder="6366F1" maxlength="7" />' +
                    '</div>' +
                    // Actions
                    '<div class="cf-cp-actions">' +
                        '<button type="button" class="tb-btn cf-cp-action-btn" id="cf-cp-save-btn">' +
                            'Save' +
                        '</button>' +
                        '<button type="button" class="tb-btn cf-cp-action-btn" id="cf-cp-clear-btn">' +
                            'Clear' +
                        '</button>' +
                    '</div>' +
                '</div>' +
            '</div>';

        document.body.insertAdjacentHTML('beforeend', html);

        // SV canvas events
        var svCanvas = document.getElementById('cf-cp-sv-canvas');
        svCanvas.addEventListener('mousedown', function (e) { _draggingSV = true; _handleSVMove(e); });
        document.addEventListener('mousemove', function (e) { if (_draggingSV) _handleSVMove(e); });
        document.addEventListener('mouseup', function () { _draggingSV = false; });
        // Touch support
        svCanvas.addEventListener('touchstart', function (e) { e.preventDefault(); _draggingSV = true; _handleSVMove(e.touches[0]); }, { passive: false });
        document.addEventListener('touchmove', function (e) { if (_draggingSV) { e.preventDefault(); _handleSVMove(e.touches[0]); } }, { passive: false });
        document.addEventListener('touchend', function () { _draggingSV = false; });

        // Hue canvas events
        var hueCanvas = document.getElementById('cf-cp-hue-canvas');
        hueCanvas.addEventListener('mousedown', function (e) { _draggingHue = true; _handleHueMove(e); });
        document.addEventListener('mousemove', function (e) { if (_draggingHue) _handleHueMove(e); });
        document.addEventListener('mouseup', function () { _draggingHue = false; });
        // Touch support
        hueCanvas.addEventListener('touchstart', function (e) { e.preventDefault(); _draggingHue = true; _handleHueMove(e.touches[0]); }, { passive: false });
        document.addEventListener('touchmove', function (e) { if (_draggingHue) { e.preventDefault(); _handleHueMove(e.touches[0]); } }, { passive: false });
        document.addEventListener('touchend', function () { _draggingHue = false; });

        // Hex input live preview
        document.getElementById('cf-cp-hex-input').addEventListener('input', function () {
            var v = this.value.replace(/[^0-9a-fA-F#]/g, '');
            this.value = v;
            var hex = v.startsWith('#') ? v : '#' + v;
            var rgb = hexToRgb(hex);
            if (rgb) {
                var hsv = rgbToHsv(rgb.r, rgb.g, rgb.b);
                _hue = hsv.h;
                _sat = hsv.s;
                _val = hsv.v;
                _drawSVCanvas();
                _updateSVCursor();
                _updateHueCursor();
                _updatePreviewBlock();
                _markActiveSwatch(hex);
            }
        });

        // Swatch click delegation
        document.getElementById('cf-cp-swatch-grid').addEventListener('click', function (e) {
            var swatch = e.target.closest('.cf-cp-swatch');
            if (!swatch) return;
            var color = swatch.dataset.color;
            _setColorFromHex(color);
        });

        // Save button
        document.getElementById('cf-cp-save-btn').addEventListener('click', function () {
            _save();
        });

        // Clear button
        document.getElementById('cf-cp-clear-btn').addEventListener('click', function () {
            _clear();
        });

        // Close on outside click
        document.addEventListener('click', function (e) {
            var popover = document.getElementById('cf-color-picker-popover');
            if (!popover || popover.style.display === 'none') return;
            if (!e.target.closest('#cf-color-picker-popover') && !e.target.closest('.cf-color-swatch-btn')) {
                close();
            }
        });

        // Draw hue bar once
        _drawHueCanvas();
    }

    // ????????????????????????????????????????????????????????
    // Canvas drawing
    // ????????????????????????????????????????????????????????
    function _drawSVCanvas() {
        var canvas = document.getElementById('cf-cp-sv-canvas');
        if (!canvas) return;
        var ctx = canvas.getContext('2d');
        var w = canvas.width;
        var h = canvas.height;

        // Fill with hue color
        var hueRgb = hsvToRgb(_hue, 1, 1);
        ctx.fillStyle = 'rgb(' + hueRgb.r + ',' + hueRgb.g + ',' + hueRgb.b + ')';
        ctx.fillRect(0, 0, w, h);

        // White gradient left to right
        var gradWhite = ctx.createLinearGradient(0, 0, w, 0);
        gradWhite.addColorStop(0, 'rgba(255,255,255,1)');
        gradWhite.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = gradWhite;
        ctx.fillRect(0, 0, w, h);

        // Black gradient top to bottom
        var gradBlack = ctx.createLinearGradient(0, 0, 0, h);
        gradBlack.addColorStop(0, 'rgba(0,0,0,0)');
        gradBlack.addColorStop(1, 'rgba(0,0,0,1)');
        ctx.fillStyle = gradBlack;
        ctx.fillRect(0, 0, w, h);
    }

    function _drawHueCanvas() {
        var canvas = document.getElementById('cf-cp-hue-canvas');
        if (!canvas) return;
        var ctx = canvas.getContext('2d');
        var w = canvas.width;
        var h = canvas.height;

        var grad = ctx.createLinearGradient(0, 0, w, 0);
        grad.addColorStop(0,     '#FF0000');
        grad.addColorStop(0.17,  '#FFFF00');
        grad.addColorStop(0.33,  '#00FF00');
        grad.addColorStop(0.50,  '#00FFFF');
        grad.addColorStop(0.67,  '#0000FF');
        grad.addColorStop(0.83,  '#FF00FF');
        grad.addColorStop(1,     '#FF0000');
        ctx.fillStyle = grad;

        // Draw with rounded corners
        var r = 7;
        ctx.beginPath();
        ctx.moveTo(r, 0);
        ctx.lineTo(w - r, 0);
        ctx.quadraticCurveTo(w, 0, w, r);
        ctx.lineTo(w, h - r);
        ctx.quadraticCurveTo(w, h, w - r, h);
        ctx.lineTo(r, h);
        ctx.quadraticCurveTo(0, h, 0, h - r);
        ctx.lineTo(0, r);
        ctx.quadraticCurveTo(0, 0, r, 0);
        ctx.closePath();
        ctx.fill();
    }

    // ????????????????????????????????????????????????????????
    // Cursor updates
    // ????????????????????????????????????????????????????????
    function _updateSVCursor() {
        var canvas = document.getElementById('cf-cp-sv-canvas');
        var cursor = document.getElementById('cf-cp-sv-cursor');
        if (!canvas || !cursor) return;
        var x = _sat * canvas.width;
        var y = (1 - _val) * canvas.height;
        cursor.style.left = x + 'px';
        cursor.style.top = y + 'px';
    }

    function _updateHueCursor() {
        var canvas = document.getElementById('cf-cp-hue-canvas');
        var cursor = document.getElementById('cf-cp-hue-cursor');
        if (!canvas || !cursor) return;
        var x = (_hue / 360) * canvas.width;
        cursor.style.left = x + 'px';
    }

    function _updatePreviewBlock() {
        var hex = hsvToHex(_hue, _sat, _val);
        var preview = document.getElementById('cf-cp-color-preview');
        if (preview) preview.style.background = hex;
        var hexInput = document.getElementById('cf-cp-hex-input');
        if (hexInput) hexInput.value = hex;
    }

    // ????????????????????????????????????????????????????????
    // Mouse/touch handlers
    // ????????????????????????????????????????????????????????
    function _handleSVMove(e) {
        var canvas = document.getElementById('cf-cp-sv-canvas');
        if (!canvas) return;
        var rect = canvas.getBoundingClientRect();
        var x = Math.max(0, Math.min(e.clientX - rect.left, rect.width));
        var y = Math.max(0, Math.min(e.clientY - rect.top, rect.height));
        _sat = x / rect.width;
        _val = 1 - (y / rect.height);
        _updateSVCursor();
        _updatePreviewBlock();
        _markActiveSwatch(hsvToHex(_hue, _sat, _val));
    }

    function _handleHueMove(e) {
        var canvas = document.getElementById('cf-cp-hue-canvas');
        if (!canvas) return;
        var rect = canvas.getBoundingClientRect();
        var x = Math.max(0, Math.min(e.clientX - rect.left, rect.width));
        _hue = (x / rect.width) * 360;
        _drawSVCanvas();
        _updateSVCursor();
        _updateHueCursor();
        _updatePreviewBlock();
        _markActiveSwatch(hsvToHex(_hue, _sat, _val));
    }

    // ????????????????????????????????????????????????????????
    // Internal helpers
    // ????????????????????????????????????????????????????????
    function _setColorFromHex(hex) {
        var rgb = hexToRgb(hex);
        if (!rgb) return;
        var hsv = rgbToHsv(rgb.r, rgb.g, rgb.b);
        _hue = hsv.h;
        _sat = hsv.s;
        _val = hsv.v;
        _drawSVCanvas();
        _updateSVCursor();
        _updateHueCursor();
        _updatePreviewBlock();
        _markActiveSwatch(hex);
    }

    function _markActiveSwatch(color) {
        var swatchEls = document.querySelectorAll('#cf-cp-swatch-grid .cf-cp-swatch');
        swatchEls.forEach(function (s) {
            s.classList.toggle('active', s.dataset.color.toLowerCase() === (color || '').toLowerCase());
        });
    }

    function _save() {
        var hex = document.getElementById('cf-cp-hex-input').value.trim();
        if (_currentOpts && hex) {
            var textEl = document.getElementById(_currentOpts.textId);
            if (textEl) {
                textEl.value = hex;
                textEl.dispatchEvent(new Event('input', { bubbles: true }));
            }
            if (_currentOpts.dotId) {
                var dot = document.getElementById(_currentOpts.dotId);
                if (dot) dot.style.background = hex;
            }
            if (_currentOpts.previewId && _currentOpts.iconInputId) {
                CF.iconPicker.updatePreview(_currentOpts.iconInputId, _currentOpts.previewId, hex);
            }
            if (typeof _currentOpts.onSave === 'function') {
                _currentOpts.onSave(hex);
            }
        }
        close();
    }

    function _clear() {
        if (_currentOpts) {
            var textEl = document.getElementById(_currentOpts.textId);
            if (textEl) {
                textEl.value = '';
                textEl.dispatchEvent(new Event('input', { bubbles: true }));
            }
            if (_currentOpts.dotId) {
                var dot = document.getElementById(_currentOpts.dotId);
                if (dot) dot.style.background = '#F1F5F9';
            }
            if (_currentOpts.previewId && _currentOpts.iconInputId) {
                CF.iconPicker.updatePreview(_currentOpts.iconInputId, _currentOpts.previewId, '');
            }
            if (typeof _currentOpts.onClear === 'function') {
                _currentOpts.onClear();
            }
        }
        close();
    }

    // ????????????????????????????????????????????????????????
    // Public API
    // ????????????????????????????????????????????????????????

    /**
     * Open the color picker popover.
     * @param {object} opts
     * @param {string} opts.textId � ID of text input to write hex value
     * @param {string} opts.triggerId � ID of the trigger button (for positioning)
     * @param {string} [opts.dotId] � ID of color preview dot
     * @param {string} [opts.previewId] � ID of icon preview element
     * @param {string} [opts.iconInputId] � ID of icon input (for icon preview color sync)
     * @param {function} [opts.onSave] � Callback(hex) after save
     * @param {function} [opts.onClear] � Callback after clear
     */
    function open(opts) {
        _ensureInjected();
        _currentOpts = opts;

        var currentVal = '';
        var textEl = document.getElementById(opts.textId);
        if (textEl) currentVal = textEl.value || '';

        if (currentVal && hexToRgb(currentVal)) {
            _setColorFromHex(currentVal);
        } else {
            _hue = 240; _sat = 0.58; _val = 0.95;
            _drawSVCanvas();
            _updateSVCursor();
            _updateHueCursor();
            _updatePreviewBlock();
            _markActiveSwatch('');
        }

        // Position popover near the trigger
        var trigger = document.getElementById(opts.triggerId);
        var popover = document.getElementById('cf-color-picker-popover');

        popover.style.display = 'block';

        if (trigger) {
            var rect = trigger.getBoundingClientRect();
            var popRect = popover.getBoundingClientRect();
            var top = rect.bottom + 8;
            var left = rect.left;

            if (top + popRect.height > window.innerHeight - 16) {
                top = rect.top - popRect.height - 8;
            }
            if (left + popRect.width > window.innerWidth - 16) {
                left = window.innerWidth - popRect.width - 16;
            }

            popover.style.top = top + 'px';
            popover.style.left = left + 'px';
        }
    }

    function close() {
        var popover = document.getElementById('cf-color-picker-popover');
        if (popover) popover.style.display = 'none';
        _currentOpts = null;
    }

    return {
        SWATCHES: SWATCHES,
        open:     open,
        close:    close
    };
})();
